import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';

import { userService } from '../../application/UserService';
import { useShowSnackbarMessage } from '../snackbarMessage/useShowSnackbarMessage';

interface UseResendUserValidationEmail {
  email: string;
}

type UseResendUserValidationEmailResponse = ServiceResponse<() => void, void>;

// Hooks act as 'Adapter' layer.
const useResendUserValidationEmail = ({
  email,
}: UseResendUserValidationEmail): UseResendUserValidationEmailResponse => {
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const { isError, refetch, isSuccess, isLoading } = useQuery(
    [`planner_resend_validation_email`],
    () => userService.resendValidationEmail({ email }),
    {
      enabled: false,
      retry: false,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        showSnackbarMessage({
          type: `success`,
          messageIntlId: `infoerror.mailsuccesssended`,
        });
      },
      onError: (err: any) => {
        console.info(`Resend Validation Email User Error: `, err?.response);

        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    success: isSuccess,
    error: isError,
    isLoading,
    run: () => refetch(),
  };
};

export default useResendUserValidationEmail;
